import request from "../request";

export function getMenuPage(params) {
  return request.get("/api/admin/menus/page", { params });
}

export function getMenuList() {
  return request.get("/api/admin/menus");
}

/** 管理端「菜单维护」：需 sys:menu:view */
export function getMenuTree() {
  return request.get("/api/admin/menus/tree");
}

/** 侧边栏：按当前用户已分配权限过滤 */
export function getMyMenuTree() {
  return request.get("/api/me/menus/tree");
}

export function createMenu(data) {
  return request.post("/api/admin/menus", data);
}

export function updateMenu(id, data) {
  return request.put(`/api/admin/menus/${id}`, data);
}

export function removeMenu(id) {
  return request.delete(`/api/admin/menus/${id}`);
}

export function getMenuPermissions(id) {
  return request.get(`/api/admin/menus/${id}/permissions`);
}

export function assignMenuPermissions(id, permissionIds) {
  return request.put(`/api/admin/menus/${id}/permissions`, { permissionIds });
}
